import React, { useState } from 'react';

import { Button, Form, Modal } from 'react-bootstrap';

import SearchIcon from '../../assets/svg/Search';
import Up from '../../assets/svg/Up';

export interface sirenData {
  name: string;
  city: string;
  zip: string;
  address: string;
  siren: string;
}

const ModalSirenSearch = (props: any) => {
  const [siren, setSiren] = useState<string>();
  const [company, setCompany] = useState<sirenData[]>();

  const handleClose = () => {
    props.setShow(false);
  };

  const handleSelect = (value: string) => {
    props.setSirenValue(value);
    handleClose();
  };

  const handleSubmit = () => {
    props.getCompanyInfos(siren).then((comp: sirenData[]) => {
      setCompany(comp);
    });
  };

  return (
    <Modal show={props.show} onHide={handleClose}>
      <div className="d-flex flex-column justify-content-center m-4">
        <div className="mb-3 d-flex flex-row justify-content-between">
          <div className="d-flex flex-row justify-content-start gap-2 mb-0 pb-0">
            <h4 className="short-agenda-modal mt-3 pt-2">
              <p className="fw-bold">Recherche de la société par nom ou SIREN</p>
            </h4>
          </div>
          <Button variant="none" onClick={handleClose}>
            <Up color="#000D5B" />
          </Button>
        </div>
        <Form className="d-flex mb-5">
          <Form.Group className="d-flex flex-row justify-content-start w-100" controlId="siren" onSubmit={handleSubmit}>
            <Form.Control
              className="mr-2 rounded-end"
              type="text"
              onChange={(e) => setSiren(e.target.value)}
              placeholder="Raison sociale ou Siren"
              required
            />
          </Form.Group>
          <Button variant="primary" onClick={handleSubmit} className="rounded-start">
            <SearchIcon />
          </Button>
        </Form>
        {company && (
          <p className="text-muted">
            Nous avons trouvé {company.length} société(s) correspondant au nom ou SIREN recherché. Sélectinnez la bonne
            parmi la liste :
          </p>
        )}

        {company &&
          company.map((comp, i) => (
            <div key={i} className="lavender-box p-4 mb-3">
              <div className="d-flex flex-row gap-2 register-text-color">
                <p className="mt-0 mb-0 fw-bold">Nom : </p>
                {comp.name}
              </div>
              <div className="d-flex flex-row gap-2 register-text-color">
                <p className="mt-0 mb-0 fw-bold">Ville : </p>
                {comp.city} {comp.zip}
              </div>
              <div className="d-flex flex-row gap-2 register-text-color">
                <p className="mt-0 mb-0 fw-bold">Adresse : </p>
                {comp.address}
              </div>
              <div className="d-flex flex-row gap-2 register-text-color">
                <p className="mt-0 mb-0 fw-bold">Siren : </p>
                {comp.siren}
              </div>
              <Button
                variant="none"
                className="text-start register-info2 text-decoration-none link p-0"
                onClick={() => handleSelect(comp.siren)}
              >
                Choisir
              </Button>
            </div>
          ))}
      </div>
    </Modal>
  );
};

export default ModalSirenSearch;
